import { Instance } from 'mobx-state-tree';
import { RouteStopMovingDtoModelBase } from './RouteStopMovingDtoModel.base';

/* The TypeScript type of an instance of RouteStopMovingDtoModel */
export interface RouteStopMovingDtoModelType extends Instance<typeof RouteStopMovingDtoModel.Type> {}

/* A graphql query fragment builders for RouteStopMovingDtoModel */
export { selectFromRouteStopMovingDto, routeStopMovingDtoModelPrimitives, RouteStopMovingDtoModelSelector } from './RouteStopMovingDtoModel.base';

/**
 * RouteStopMovingDtoModel
 *
 * Route moving stop event
 */
export const RouteStopMovingDtoModel = RouteStopMovingDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
